import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const LockFilled = () => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.024 6.024V5.024C13.024 2.864 12.504 0 8 0C3.496 0 2.976 2.864 2.976 5.024V6.024C0.736 6.304 0 7.44 0 10.232V11.72C0 15 1 16 4.28 16H11.72C15 16 16 15 16 11.72V10.232C16 7.44 15.264 6.304 13.024 6.024ZM8 13.392C6.664 13.392 5.584 12.304 5.584 10.976C5.584 9.64 6.672 8.56 8 8.56C9.328 8.56 10.416 9.648 10.416 10.976C10.416 12.312 9.336 13.392 8 13.392ZM4.28 5.952C4.216 5.952 4.16 5.952 4.096 5.952V5.024C4.096 2.68 4.76 1.12 8 1.12C11.24 1.12 11.904 2.68 11.904 5.024V5.96C11.84 5.96 11.784 5.96 11.72 5.96H4.28V5.952Z" />
  </svg>
)

export default withDefaultStyles(LockFilled)
